import { useState, useEffect } from 'react';

interface HeroProps {
  isVisible: boolean;
}

export default function Hero({ isVisible }: HeroProps) {
  const [animateHeadline, setAnimateHeadline] = useState(false);
  const [animateSubtitle, setAnimateSubtitle] = useState(false);
  const [animateButton, setAnimateButton] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => setAnimateHeadline(true), 200);
      setTimeout(() => setAnimateSubtitle(true), 500);
      setTimeout(() => setAnimateButton(true), 800);
    }
  }, [isVisible]);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511985111042?text=Olá! Gostaria de solicitar um orçamento exclusivo.', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden w-full">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/7ccf2b61461836e660f784fcb2be72f9.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-5 sm:px-8 py-20 text-center">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/44ac6951-7957-465a-b660-4b544ef0dc70.png" 
              alt="Realeza Tapeçaria & Design"
              className="h-32 sm:h-44 md:h-56 mx-auto mb-8 md:mb-12 object-contain"
            />
          </div>

          <h1 
            className={`text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight transition-all duration-1000 ${
              animateHeadline ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Realeza Tapeçaria & Design: A Arte de Transformar Ambientes em São Paulo há 35 Anos.
          </h1>

          <p 
            className={`text-sm sm:text-lg md:text-xl text-gray-100 mb-10 max-w-4xl mx-auto leading-relaxed transition-all duration-1000 delay-300 ${
              animateSubtitle ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Unimos a tradição da tapeçaria clássica à sofisticação do design contemporâneo. Excelência em reforma de estofados, móveis sob medida e projetos de decoração exclusivos para quem não abre mão do impecável.
          </p>

          <button
            onClick={handleWhatsAppClick}
            className={`bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-3 sm:px-10 sm:py-5 rounded-lg text-xs sm:text-lg font-semibold shadow-2xl hover:shadow-emerald-500/50 transition-all duration-300 hover:scale-105 whitespace-normal sm:whitespace-nowrap cursor-pointer mx-auto block sm:inline-block max-w-[260px] sm:max-w-none ${
              animateButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Solicitar Orçamento Exclusivo via WhatsApp
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
